import './FullImage.scss';

class FullImage {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['FullImage'] = FullImage;
export default FullImage;
